export default {
  computed: {
    valid () {
      return this.periodOfStay.valid &&
        this.contactDetails.valid &&
        this.registration.valid &&
        this.moreInformation.valid &&
        this.authorization.valid &&
        !this.$store.getters['submission']
    },
  },

  methods: {
    onSubmit () {
      let dataForm = {
        period: this.periodOfStay.period,
        qualified_period: this.periods[this.periodOfStay.period.split('-')[1]],
        sex: this.contactDetails.sex,
        lastName: this.contactDetails.lastName,
        firstName: this.contactDetails.firstName,
        nationality: this.contactDetails.nationality,
        birthday: this.contactDetails.birthday,
        birthLocation: this.contactDetails.birthLocation,
        address: this.contactDetails.address,
        zipCode: this.contactDetails.zipCode,
        city: this.contactDetails.city,
        country: this.contactDetails.country,
        mail: this.contactDetails.mail,
        originEntity: this.registration.originEntity,
        registrationFaculty: this.registration.registrationFaculty,
        registrationPersuedDegree: this.registration.registrationPersuedDegree,
        exchangeProgram: this.registration.exchangeProgram,
        arrivalDate: this.moreInformation.arrivalDate,
        informationMessage: this.moreInformation.informationMessage,
      }

      if (
        this.registration.exchangeProgram === 'ep-erasmusMundus' ||
        this.registration.exchangeProgram === 'ep-other'
      ) {
        dataForm.titleOther = this.registration.titleOther
      }

      if (this.accommodation.choiceCrous) {
        dataForm.crousRoomChoices = this.accommodation.crousRoomChoices
        dataForm.legalNoticeDormitory = this.authorization.legalNoticeDormitory
        dataForm.legalNoticeCROUS = this.authorization.legalNoticeCROUS
      }

      if (this.accommodation.mui) {
        dataForm.muiChoice1 = this.accommodation.muiChoice1
        dataForm.muiChoice2 = this.accommodation.muiChoice2
        dataForm.muiChoice3 = this.accommodation.muiChoice3
        dataForm.muiAuthorizationChecker = this.authorization.muiAuthorizationChecker
      }

      dataForm.population = 'sep-' + this.subPopulation
      dataForm.lang = this.$t('lang')
      this.$store.dispatch('postFormValues', dataForm)
        .then(() => {
          this.$store.dispatch('postFormValuesValidation', dataForm)
          this.resetData()
        })
        .catch(() => {
          this.$store.dispatch('postFormValuesError')
        })
    },
  },
}
